import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      sm: 768,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  typography: {
    fontFamily: [`var(--fontFamilyBody)`, 'sans-serif']
  },
  overrides: {
    MuiMenuItem: {
      root: {
        color: 'inherit',

        '&:hover': {
          color: 'var(--colorMainBlue)'
        }
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 38,
        color: 'currentColor'
      }
    },
    MuiListSubheader: {
      root: {
        lineHeight: 2,
        fontWeight: 700,
        color: 'inherit',
        marginTop: 5
      }
    },
    MuiIconButton: {
      root: {
        color: 'inherit',

        '&:hover': {
          color: 'var(--colorMainBlue)',
          backgroundColor: 'transparent'
        }
      }
    }
  }
});

export default theme;
